import React, { useState } from 'react';

interface ReporteProps {
    url: string;
    height: string;
    width: string;
}

const Reporte: React.FC<ReporteProps> = ({ url, width }) => {
    const [iframeError, setIframeError] = useState<string>('');

    const handleIframeError = () => {
        console.error('Error al cargar el iframe');
        setIframeError('Error al cargar el reporte. Por favor, intente nuevamente.');
    };

    return (
        <div style={{ width, height: '100%', position: 'relative' }}>
            {iframeError ? (
                <div style={{ 
                    color: 'red', 
                    padding: '10px 20px 20px',
                    textAlign: 'center',
                    border: '1px solid red',
                    borderRadius: '4px'
                }}>
                    {iframeError}
                </div>
            ) : (
                <iframe
                    src={url}
                    style={{
                        width: '100%',
                        height: '100%',
                        border: 'none',
                        position: 'absolute', 
                        top: 0,
                        left: 0
                    }}
                    title="Reporte BI"
                    allowFullScreen
                    onError={handleIframeError}
                />
            )}
        </div>
    );
};

export default Reporte;
